import { render, staticRenderFns } from "./GalleryPopup.vue?vue&type=template&id=ba8ea8c8&"
import script from "./GalleryPopup.vue?vue&type=script&lang=js&"
export * from "./GalleryPopup.vue?vue&type=script&lang=js&"
import style0 from "./GalleryPopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports